import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from './components/NavBar';
import { EngineeringPlatform } from './components/EngineeringPlatform';

function App() {
  return (
    <div className="App">
      <NavBar />
      <EngineeringPlatform />
    </div>
  );
}

export default App;
